/* Root Reducer */

import { combineReducers } from 'redux';

import { pmaReducer } from './pma.reducer';
import { homeReducer } from './home.reducer';
import { roiReducer } from './roi.reducer';
const rootReducer = () => combineReducers({
  pma: pmaReducer,
  home: homeReducer,
  roi: roiReducer,
});

export default rootReducer;